// extracted by mini-css-extract-plugin
export default {"entityTable":"gIIv3yXkVEKyfUy9ya1a"};